module.exports = __webpack_public_path__ + "img/samsung-galaxy-a5.8157b0bc.png";